import { Controller } from "@hotwired/stimulus"

// Live preview of the PDP suggested-questions pills. Mirrors the storefront render
// (chicago section-element.ts): a heading + spark in the accent color, and pills as the theme's CTA
// button (accent background, accent-text color). Re-styles on every edit to the appearance fields.
// Custom CSS is intentionally not previewed — it targets the section's shadow DOM at runtime.
export default class extends Controller {
  static targets = [
    "label", "accentPicker", "textPicker", "fontSize", "fontFamily",
    "previewRoot", "previewLabel", "previewSpark", "previewLabelText", "pill",
  ]

  connect() {
    this.update()
  }

  update() {
    const accent = this.hasAccentPickerTarget ? this.accentPickerTarget.value : "#FFC933"
    const textColor = this.hasTextPickerTarget ? this.textPickerTarget.value : "#000000"
    const label = (this.hasLabelTarget && this.labelTarget.value.trim()) || "Ask anything"
    const fontSize = (this.hasFontSizeTarget && this.fontSizeTarget.value) || "15"
    const fontFamily = (this.hasFontFamilyTarget && this.fontFamilyTarget.value.trim()) || "inherit"

    if (this.hasPreviewRootTarget) {
      this.previewRootTarget.style.fontFamily = fontFamily
      this.previewRootTarget.style.fontSize = `${fontSize}px`
    }
    if (this.hasPreviewLabelTarget) this.previewLabelTarget.style.color = accent
    if (this.hasPreviewSparkTarget) this.previewSparkTarget.style.color = accent
    if (this.hasPreviewLabelTextTarget) this.previewLabelTextTarget.textContent = label

    this.pillTargets.forEach((pill) => {
      pill.style.background = accent
      pill.style.color = textColor
    })
  }
}
